import React from 'react';

export const VideoIcon = () => {
  return (
    <svg
      width="18"
      height="12"
      viewBox="0 0 18 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 2C0 0.90625 0.875 0 2 0H10C11.0938 0 12 0.90625 12 2V10C12 11.125 11.0938 12 10 12H2C0.875 12 0 11.125 0 10V2ZM17.4688 1.125C17.7812 1.3125 18 1.65625 18 2V10C18 10.375 17.7812 10.7188 17.4688 10.9062C17.125 11.0625 16.75 11.0625 16.4375 10.8438L13.4375 8.84375L13 8.5625V8V4V3.46875L13.4375 3.1875L16.4375 1.1875C16.75 0.96875 17.125 0.96875 17.4688 1.125Z"
        fill="#737373"
      />
    </svg>
  );
};
